/* eslint-disable no-nested-ternary */
import styled, { css } from "styled-components";

const sharedStyles = css`
  display: flex;
  height: 42px;
  width: 100%;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  padding: 0 14px;
  color: ${(props: any) => (props.disabled ? "#a0a0a0" : "#333")};
  font-size: 14px;
  font-family: Inter;
  :focus {
    border: none;
    -webkit-appearance: none;
    outline: none;
  }
  ::placeholder {
    color: #a3a3a6;
  }
`;

export const ContainerInput: any = styled.div`
  display: flex;
  height: ${(props: any) =>
    props.height ? props.height : props.multiline ? "80px" : "44px"};
  width: 100%;
  border-radius: 8px;
  background-color: ${(props: any) =>
    props.matchDisabled && props.disabled
      ? "rgb(208, 213, 221)"
      : props.disabled
      ? "rgba(0,0,0,0.08)"
      : "#ffffff"};
  border-width: ${(props: any) => (props.isFocused ? 2 : 1)}px;
  border-style: solid;
  border-color: ${(props: any) =>
    props.isFocused ? "#4a76fb" : props.borderColor ?? "#C4C4C4"};
  transition: border-color 0.2s ease-in;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  overflow: hidden;
`;

export const Input = styled.input`
  ${sharedStyles}
`;

export const TextArea = styled.textarea`
  ${sharedStyles}
  padding: 6px 14px;
`;
